import { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Radio } from 'antd'

import B2bCustomModal from '@/components/B2bCustomModal'
import B2becAddressForm from '@/components/B2becAddressForm'
import { DeliveryAddress } from '@/components/DisplayAddress/DeliveryAddress'
import SearchAddress from '@/pages/CheckoutPage/StepOneComponent/SearchAddress'
import { useAppSelector } from '@/store/hook'
import { selectUserCountry } from '@/store/selectors/userSelector'
import { selectDeliveryAddresses } from '@/store/slices/customerSlice'

interface SelectAddressMobileProps {
  value?: {
    partnerNumber?: string
  }
  isModalVisible?: boolean
  onCancel?: (...args: unknown[]) => unknown
  onChange?: (...args: unknown[]) => unknown
}

const SelectAddressMobile = (props: SelectAddressMobileProps) => {
  const { value, onChange, isModalVisible = false, onCancel } = props
  const { t } = useTranslation()
  const deliveryAddresses = useAppSelector(selectDeliveryAddresses)
  const country = useAppSelector(selectUserCountry)
  const [isSearchAddress, setIsSearchAddress] = useState(false)
  const selectedPartnerNumber = value?.partnerNumber
  const isAddNewAddress = !selectedPartnerNumber

  const first3Addresses = useMemo(() => {
    if (Array.isArray(deliveryAddresses)) {
      if (isSearchAddress) {
        return deliveryAddresses.filter(
          ({ partnerNumber }) => partnerNumber === selectedPartnerNumber,
        )
      }
      return deliveryAddresses.slice(0, 3)
    }

    return []
  }, [deliveryAddresses, isSearchAddress, selectedPartnerNumber])

  const onChangeValue = useCallback(
    (data) => {
      onChange?.({ ...data, isAddNew: !isAddNewAddress })
    },
    [onChange, isAddNewAddress],
  )

  const handleAddNewAddress = useCallback(
    (values) => {
      if (!values.isShow) {
        onChangeValue({})
      }
    },
    [onChangeValue],
  )

  const handleCancel = useCallback(() => {
    setIsSearchAddress(true)
    onCancel?.()
  }, [onCancel])

  return (
    <div className="custom-input">
      {first3Addresses.map((data) => {
        return (
          <Radio
            key={data.partnerNumber}
            checked={data.partnerNumber === selectedPartnerNumber}
            className="delivery-information-radio border-bottom"
            onClick={() => onChangeValue(data)}
          >
            <DeliveryAddress data={data} />
          </Radio>
        )
      })}
      <Radio
        checked={isAddNewAddress}
        className="delivery-information-radio border-bottom"
        onClick={() => onChangeValue({ country })}
      >
        <span className="mt-6 mb-4 delivery__option__title">
          {t('form.label.newAddress')}
        </span>
      </Radio>

      {isAddNewAddress && <B2becAddressForm id="deliveryAddress" onChange={handleAddNewAddress} />}

      <B2bCustomModal isFullScreen open={isModalVisible}>
        <SearchAddress
          dataSource={deliveryAddresses}
          value={value}
          onCancel={handleCancel}
          onChange={onChangeValue}
        />
      </B2bCustomModal>
    </div>
  )
}

export default SelectAddressMobile
